import { Controller } from 'stimulus';
import { delegate } from 'ez-styles/assets/javascripts/ez-styles/utils/helpers';
import {
  getFormattedPageValue,
  postAjax,
  triggerCustomEvent,
  makeQueryParams,
} from 'lib/helpers';
import { makeDataHashFromState } from 'lib/state-helpers';

let ezPaginationFlag = true;

export default class NumPagerController extends Controller {
  static targets = ['currentPage', 'totalPages'];

  connect() {
    this.original_content = null; // var to hold the pager's original value;
    this.element.setAttribute('data-loaded', 'true');

    this.setupEventHandlers();
  }

  setupEventHandlers() {
    // on focus set original_content to the current value and then set the pager to blank;
    delegate(
      this.element,
      'focus',
      'is-current',
      () => {
        this.original_content = this.currentPageTarget.innerHTML;
        this.currentPageTarget.innerHTML = '';
      },
      true,
    );

    // enable onfocusout when component loaded
    this.setFocusOut();

    // enable keypress when document ready
    this.setKeypress();

    if (ezPaginationFlag === true) {
      ezPaginationFlag = false;

      window.addEventListener('PaginationChanged', (event) => {
        const dataHash = makeDataHashFromState(
          event.detail.stateKey,
          event.detail.extraStates,
        );

        dataHash.page = event.detail.page;

        if (event.detail.ajaxEventName) {
          postAjax(event.detail.ajaxEventName, dataHash);
        } else {
          Turbolinks.visit(window.location.pathname + makeQueryParams(dataHash));
        }
      });
    }
  }

  pageChange = (event) => {
    event.preventDefault();

    const dir = event.currentTarget.getAttribute('rel');

    const pageTo = dir === 'next'
      ? parseInt(getFormattedPageValue(this.currentPageTarget), 10) + 1
      : parseInt(getFormattedPageValue(this.currentPageTarget), 10) - 1;

    // Once we have a valid page number to go to... go!
    this.firePaginationEvent(pageTo);
  };

  firePaginationEvent(pageTo) {
    const paginationEvent = this.element.getAttribute('data-page-change-event');
    triggerCustomEvent(paginationEvent, {
      page: pageTo,
      oldPage: parseInt(getFormattedPageValue(this.currentPageTarget), 10),
    });
  }

  setFocusOut() {
    // on focus out validate the pager this handles when a user clicks out of the pager
    delegate(this.element, 'focusout', 'is-current', this.validatePager, true);
  }

  setKeypress() {
    // when the pager has focus and the enter key is pressed
    delegate(
      this.element,
      'keypress',
      'is-current',
      this.keypressListener,
      true,
    );
  }

  keypressListener = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // prevent the default actions (line return)

      this.validatePager(); // validate pager contents

      this.currentPageTarget.blur(); // deselect the pager
    }
  };

  validatePager = () => {
    let curValue = getFormattedPageValue(this.currentPageTarget); // get current pager value
    console.log(typeof curValue);


    const maxValue = this.getFormattedMaxValue(); // get the total number of pages

    // if the number given is greater than the number of pages, set it to the max
    if (curValue > maxValue) {
      this.currentPageTarget.innerHTML = maxValue;

      curValue = getFormattedPageValue(this.currentPageTarget); // udpate curValue because we've changed it
    }

    // if it is blank or zero or isn't a number set it back to original value
    if (
      curValue === ''
      || curValue === '0'
      || Number.isNaN(parseInt(curValue, 10))
    ) {
      this.currentPageTarget.innerHTML = this.original_content;
      return;
    }

    // if user enters current page number, do nothing
    if (curValue === this.original_content) {
      return; // break out
    }

    // Once we have a valid page number to go to... go!
    this.firePaginationEvent(curValue);
  };

  getFormattedMaxValue() {
    let maxValue = this.totalPagesTarget.innerHTML; // get the total number of pages
    maxValue = maxValue.replace(/[, ]+/g, ''); // remove all white space and commas
    maxValue = maxValue.match(/\d+/g); // remove all non digits
    maxValue = parseInt(maxValue, 10); // convert to int

    return maxValue;
  }
}
